import { render, staticRenderFns } from "./FreeShiftPlanningGroupEditorDialog.vue?vue&type=template&id=2587c692&scoped=true&lang=pug&"
import script from "./FreeShiftPlanningGroupEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./FreeShiftPlanningGroupEditorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587c692",
  null
  
)

export default component.exports